import React from 'react';

import PropTypes from 'prop-types';

import useIsScrolled from 'hooks/useIsScrolled';

import { CommonButton, LinkButton, ReactLinkButton } from './styles';
import { Icon } from '../Icon/Icon';

const getComponent = (type) => {
    switch (type) {
        case 'tagA':
            return LinkButton;
        case 'button':
            return CommonButton;
        default:
            return ReactLinkButton;
    }
};

const DiskButtonPure = ({ iconName = 'cross', iconColor = 'darkGray', size = 'tight', ...props }) => {
    const isScroll = useIsScrolled();
    const Wrapper = getComponent(props.type);
    const isTagA = props.type === 'tagA';
    const raised = props.raised === undefined ? isScroll : props.raised;
    return (
        <Wrapper
            aria-label={props.labelText}
            variant={props.variant}
            type={props.type === 'button' ? props.type : null}
            size={size}
            raised={isTagA ? raised : raised.toString()}
            disabled={props.disabled}
            $isInverted={props.isInverted}
            to={props.to}
            href={props.href}
            onClick={props.onClick}
            onMouseDown={props.onMouseDown}
            id={props.id}
            title={props.title}
            $marginRight={props.marginRight}
            $marginTop={props.marginTop}
            data-testid={props.dataTestId}
        >
            <Icon name={iconName} color={iconColor} size={size === 'small' ? '16px' : '24px'} />
        </Wrapper>
    );
};
export const DiskButton = React.memo(DiskButtonPure);

DiskButton.propTypes = {
    // type: <Link>(default) or <a> (type === 'tagA') or <button> (type === 'button')
    type: PropTypes.oneOf(['tagA', 'button']),
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'tertiary_light', 'error', 'errorHint']),
    size: PropTypes.oneOf(['small', 'tight', 'fit']),
    raised: PropTypes.bool,
    disabled: PropTypes.bool,
    isInverted: PropTypes.bool,
    to: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    iconColor: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
    marginRight: PropTypes.string,
    marginTop: PropTypes.string,
    labelText: PropTypes.string,
    dataTestId: PropTypes.string,
};
